var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFrenchPolynesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.35855H30.0545C27.3409 3.38506 22.0647 0.0107422 16 0.0107422C9.93531 0.0107422 4.65912 3.38506 1.94543 8.35855Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.0647 32.0107 27.3409 28.6363 30.0546 23.6628H1.94543C4.65912 28.6363 9.93531 32.0107 16 32.0107Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0107C21.5652 19.0844 19.0736 20.8803 16 20.8803C12.9264 20.8803 10.4348 19.0844 10.4348 16.0107C10.4348 12.9371 12.9264 10.4456 16 10.4456C19.0736 10.4456 21.5652 12.9371 21.5652 16.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16.0107C21.5652 19.0844 19.0736 21.5759 16 21.5759C12.9264 21.5759 10.4348 19.0844 10.4348 16.0107",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 14.6194H13.9128V17.402H12.5215V14.6194Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0867 14.6194H19.478V17.402H18.0867V14.6194Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3037 12.5325H16.695V17.402H15.3037V12.5325Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFrenchPolynesia);
export default __webpack_public_path__ + "static/media/flag_french_polynesia.5153fd1cc1d100698b2e6d494f5ea2e8.svg";
export { ForwardRef as ReactComponent };